import { IconName } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
    title: string;
    onClick: any;
    leftIcon?: string;
    rightIcon?: string;
    type?: string;
    classes?: string;
    disabled?: boolean;
    tooltip?: string;
    loading?: boolean;
    loadingText?: string;
    iconWeight?: 'fas' | 'fal' | 'far' | 'fab';
}

const Button = (props: Props) => {
    const { title, onClick, leftIcon, rightIcon, type = "primary", classes = "", disabled, tooltip, loading, loadingText, iconWeight = 'fal', style } = props;

    return (
        <button
            title={tooltip || ""}
            className={`btn btn-${type} rounded-pill ${classes} ${type !== 'linkbtn' && 'btn-lg'}`}
            onClick={onClick}
            disabled={disabled || loading}
            type="button"
            style={style}
        >
            {leftIcon ? (
                loading ? (
                    <span className="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>
                ) : (
                    <FontAwesomeIcon icon={[iconWeight, leftIcon as IconName]} className={title ? "me-2" : ""} />
                )
            ) : null}
            <span>{loading && loadingText ? loadingText : title}</span>
            {rightIcon ? (
                loading ? (
                    <span className="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>
                ) : (
                    <FontAwesomeIcon icon={[iconWeight, rightIcon as IconName]} className={title ? "ms-2" : ""} />
                )
            ) : null}
        </button>

    )
}

export default Button;